import LoadingScreen from 'app/components/LoadingScreen'
import useDodoneCollectionQuery from 'generated/api/dodones/useDodoneCollectionQuery'
import DodonesList from 'app/dodones/list/Index'

export default ({ dodoableId, limit = 0, dodoneListItemProps = {} }) => {
  const { isPending, data: { dodones, message } = {} } =
    useDodoneCollectionQuery({
      path: `api/dodoables/${dodoableId}/dodones`,
      query: { limit: limit }
    })

  if (isPending) return <LoadingScreen />
  return <DodonesList dodones={dodones} {...dodoneListItemProps} />
}
